import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
// In order to adhere to the design we need a component to render the days
export var Caption = function Caption(_ref) {
  var date = _ref.date,
    months = _ref.months,
    _ref$showYear = _ref.showYear,
    showYear = _ref$showYear === void 0 ? true : _ref$showYear;
  return ___EmotionJSX("div", {
    className: "DayPicker-Caption",
    role: "heading"
  }, ___EmotionJSX("div", null, "".concat(months[date.getMonth()]).concat(showYear ? " ".concat(date.getFullYear()) : '')));
};
export default Caption;